import { render } from "./ReviewIndex.vue?vue&type=template&id=ec5330a6&ts=true"
import script from "./ReviewIndex.vue?vue&type=script&lang=ts"
export * from "./ReviewIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__